// API Base URLs
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || 'http://localhost:5002/api';
export const SELLER_API_URL = process.env.REACT_APP_SELLER_API_URL || 'http://localhost:5001/api';

// Build timestamp to verify deployment
console.log('[BUILD] Deployed at:', new Date('2025-12-09T' + '04:15:00').toISOString());
console.log('[BUILD] AUTH_API_URL:', AUTH_API_URL);
console.log('[BUILD] SELLER_API_URL:', SELLER_API_URL);

// Token keys
export const ACCESS_TOKEN_KEY = 'taminzo_access_token';
export const REFRESH_TOKEN_KEY = 'taminzo_refresh_token';
export const USER_DATA_KEY = 'taminzo_user_data';

// Role constants
export const ROLES = {
  ADMIN: 'Admin',
  SELLER: 'Seller',
} as const;

// Payment Status
export const PAYMENT_STATUS = {
  UNPAID: 0,
  PAID: 1,
} as const;
